<template>
    <svg
        height="24px"
        width="24px"
        id="shopping-list"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 10.000000 10.000000"
        style="fill: currentColor"
    >
        <g transform="translate(0.000000,10.000000) scale(0.001019,-0.001082)">
            <path
                d="M4119 9216 c-88 -31 -139 -79 -181 -172 l-23 -49 -3 -2110 -2 -2109
-913 911 c-834 833 -916 912 -961 927 -154 50 -313 -18 -380 -163 -31 -67 -29
-179 4 -244 35 -67 2365 -2397 2430 -2430 68 -33 187 -31 255 5 37 20 350 327
1227 1205 985 986 1181 1186 1200 1228 27 62 29 170 3 230 -65 151 -234 222
-390 165 -58 -22 -93 -56 -967 -928 l-908 -906 -2 2124 -3 2125 -21 40 c-33
61 -101 123 -161 145 -61 23 -150 26 -204 6z"
            />
            <path
                d="M7085 4784 c-60 -9 -178 -33 -262 -54 -907 -231 -1599 -968 -1768
-1884 -95 -516 -23 -1026 210 -1501 413 -839 1277 -1360 2210 -1332 370 11
672 85 1000 247 705 347 1190 1015 1311 1805 25 166 25 512 1 680 -21 135 -71
338 -117 470 -44 127 -177 392 -256 510 -181 272 -430 519 -704 698 -256 167
-575 291 -890 347 -166 30 -565 37 -735 14z m1571 -1369 c80 -33 142 -119 151
-210 8 -77 -16 -140 -85 -216 -344 -383 -1348 -1483 -1381 -1513 -24 -21 -69
-50 -100 -64 -50 -24 -68 -27 -166 -27 -177 0 -169 -5 -629 432 -428 406 -431
410 -430 523 2 170 158 286 324 240 53 -15 69 -29 410 -352 172 -164 316 -298
320 -298 4 0 304 327 667 728 364 400 675 735 691 744 64 38 156 43 228 13z"
            />
            <path
                d="M219 3626 c-118 -42 -196 -139 -206 -255 -7 -76 182 -1047 233 -1201
90 -269 272 -517 519 -703 110 -83 336 -197 460 -232 201 -58 144 -56 1830
-53 l1550 3 51 27 c197 104 218 385 39 508 -91 63 -11 60 -1671 60 -1482 0
-1512 0 -1590 20 -286 73 -539 305 -623 571 -11 35 -63 287 -116 559 -104 539
-114 572 -187 635 -78 66 -201 93 -289 61z"
            />
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-already-downloaded",
});
</script>
